import { useMemo } from "react";
import { StyledAppTabs } from "./index.styled";
import { Flex } from "antd";
import PropTypes from "prop-types";

const AppTabs = (props) => {
  const { activeKey, tabItems, onChange } = props;
  const items = useMemo(() => {
    return tabItems.map((item, index) => {
      return {
        label: (
          <Flex gap={4} align="center">
            {item.icon}
            {item.label}
          </Flex>
        ),
        key: item?.key || index,
      };
    });
  }, [tabItems]);
  return (
    <StyledAppTabs activeKey={activeKey} items={items} onChange={onChange} />
  );
};

AppTabs.propTypes = {
  tabItems: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  activeKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

AppTabs.defaultProps = {
  onChange: null,
  activeKey: undefined,
};

export default AppTabs;
